import { local_search_upsert } from '@/state/search/local_search_upsert';
import { store } from '@/state/store';
import { get_entity_with_sorted_tokens_search } from '@/state/words/_methods/get_entity_with_sorted_tokens_search';
import { DTO__word } from '@shared/dto/+word/word_translated/DTO__word';
import { DTOSearchSettings } from '@shared/dto/search/dto_search_settings';
import { establish_word_object_for_tokens } from './_methods/establish_word_object_for_tokens';
import { SERVICE__translate_base } from './SERVICE__translate_base';

class ServiceTranslateSearches extends SERVICE__translate_base {
  /*
   * EVENTS
   */
  public on_searches_received(searches: DTOSearchSettings[]) {
    for (let search of searches) {
      let words_strings = search.tokens.map(token => token.word_english);

      this.register_words_dependency(search._id, words_strings);
    }
  }

  public on_language_changed() {
    let slice_workspace = store.getState().slice_workspace;
    if (!slice_workspace.is_all_data_loaded) return;

    let slice_search = store.getState().slice_search;

    let entities = Array.from(slice_search.search_history_map.values());

    //reset words for all searches to english or get translation from vocabulary
    for (let entity of entities) {
      entity.tokens = establish_word_object_for_tokens(entity.tokens);
    }

    store.dispatch(local_search_upsert(entities));
  }

  /*
   * METHODS
   */

  protected try_update_depended_entity_with_word(word: DTO__word) {
    let slice_search = store.getState().slice_search;
    let entities_ids = this.words_dependencies_map.get_or_create_set(word.word_english);

    for (let entity_id of entities_ids) {
      let search = slice_search.search_history_map.get(entity_id);
      if (!search) continue; //search deleted

      search.tokens = search.tokens.map(token => (token.word_english == word.word_english ? token.clone({ word }) : token));

      search = get_entity_with_sorted_tokens_search(search);

      store.dispatch(local_search_upsert([search]));
    }
  }
}

export const service_translate_searches = new ServiceTranslateSearches();
